import wrapWithProvider from "store/wrapWithProvider";

export const wrapApp = ({ element }: any) => wrapWithProvider(element);
